import Api from "./api"

class InfraMonitorService {
    async getProjectList(filters, mun) {
        try {
            const res = await Api.get(`${mun}/projects/filtered`, {
                params: filters,
            })
            return res.body
        } catch (error) {
            throw error
        }
    }

    async getProjects(fy) {
        try {
            const res = await Api.get("projects", {
                params: {
                    pagination: false,
                },
            })
            return this.getFYProjects(res.body, fy)
        } catch (error) {
            throw error
        }
    }



    async getProjectDetail(projectId, mun= "dhangadhi") {
        try {
            const res = await Api.get(`${mun}/projects/${projectId}`)
            return res.body
        } catch (error) {
            throw error
        }
    }

    async getProjectsStats(fy, mun = "dhangadhi") {
        try {
            const res = await Api.get("projects/stats", {
                params: {
                    "fiscal-year": fy,
                },
            })
            //format data according to fy
            return this.formatData(res.body, fy, mun)
        } catch (error) {
            throw error
        }
    }

    async getStaticData(mun) {
        try {
            const res = await Api.get(`static-data/${mun}`, {})
            return res.body
        } catch (error) {
            throw error
        }
    }

    async getSocialData(mun, fy) {
        let data;
        try{
            const res = Api.get(`${mun}/projects/stats?fiscal-year=${fy}&project-type=social`)
        }catch (error) {
            throw error
        }
    }

    getFYProjects(stats, fy) {
        let projectData = stats.data.filter(d => d.fiscal_year === fy)
        return { data: projectData }
    }

    async getProjectsStatsFiltered(filters = {}, mun = "dhangadhi") {
        try {
            const res = await Api.get(`${mun}/projects/stats`, {
                params: filters,
            })
            //format data according to fy
            return this.formatData(res.body, filters["fiscal-year"], mun)
        } catch (error) {
            throw error
        }
    }

    formatData(response, fy, mun) {
        let data = {
            data: {
                overall: {},
                ward_wise: {},
                month_wise: {},
            },
            fiscalyear: fy,
            metadata: response.metadata || {},
        }

        if (response.data && response.data[mun][fy]) {
            data.data = { ...response.data[mun][fy] }
            data.fiscalyear =  Object.keys(response.data[mun])
        }
        return data
    }

    async getLocalProjectData(mun, fy) {
        try {
            const res = await Api.get(`${mun}/local-projects/stats?fiscal-year=${fy}&project-type=local-project`);

            return res.body;
        } catch (error) {
            console.error("Error fetching local project data:", error);
            throw error;
        }
    }

    async getLocalProjectList(filters, mun) {
        try {
            const res = await Api.get(`${mun}/local-projects`, {
                params: filters,
            })
            return res.body
            } catch (error) {
                throw error
        }
    }

    async getLocalProjectDetail(projectId, mun) {
        try {
            const res = await Api.get(`${mun}/local-projects/${projectId}`)
            return res.body
            } catch (error) {
                throw error
        }
    }
}

export default new InfraMonitorService()



// WEBPACK FOOTER //
// ./src/api/infraMonitorService.js